// extracted by mini-css-extract-plugin
export default {"App":"styles_App__U4i3+"};